import * as React from "react";

const DashboardLogoRedeOkay = (props) => (
  <svg
    width={67}
    height={47}
    viewBox="0 0 67 47"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask id="path-1-inside-1_1132_1368" fill="white">
      <ellipse cx={16.1333} cy={16.8386} rx={16.1333} ry={15.8122} />
    </mask>
    <path
      d="M8.26665 16.8385C8.26665 11.8639 12.2459 8.65073 16.1333 8.65073V56.6507C37.8411 56.6507 56.2667 39.2788 56.2667 16.8385H8.26665ZM16.1333 8.65073C20.0208 8.65073 24 11.8639 24 16.8385H-24C-24 39.2788 -5.57449 56.6507 16.1333 56.6507V8.65073ZM24 16.8385C24 21.8132 20.0208 25.0264 16.1333 25.0264V-22.9736C-5.57449 -22.9736 -24 -5.60174 -24 16.8385H24ZM16.1333 25.0264C12.2459 25.0264 8.26665 21.8132 8.26665 16.8385H56.2667C56.2667 -5.60174 37.8411 -22.9736 16.1333 -22.9736V25.0264Z"
      fill="#FFE900"
      mask="url(#path-1-inside-1_1132_1368)"
    />
    <rect
      x={30.3757}
      y={1.02637}
      width={8.37951}
      height={31.8243}
      rx={4.18976}
      fill="white"
      fillOpacity={0.8}
    />
    <rect
      width={7.37451}
      height={42.4888}
      rx={3.68725}
      transform="matrix(0.769657 -0.638458 0.654172 0.756346 32.5324 14.8613)"
      fill="#FFE900"
    />
    <rect
      width={7.36034}
      height={21.5789}
      rx={3.68017}
      transform="matrix(0.704852 0.709354 -0.723376 0.690454 47.9233 0)"
      fill="#FFE900"
    />
    <path
      d="M38.7566 22.0712V8.72559C38.7566 8.72559 33.5185 12.8319 33.5434 15.154C33.2909 16.9498 35.6137 18.9915 38.7566 22.0712Z"
      fill="#FABA21"
    />
    <path
      d="M29.8517 24.6381C30.5463 24.6381 31.2125 23.8269 31.7037 22.383C32.1948 20.9391 32.4708 18.9807 32.4708 16.9387C32.4708 14.8967 32.1948 12.9383 31.7037 11.4944C31.2125 10.0504 30.5463 9.23926 29.8517 9.23926L29.8517 16.9387L29.8517 24.6381Z"
      fill="#FBB03B"
    />
  </svg>
);
export default DashboardLogoRedeOkay;
